const images = {
  commonImgAuthBackground: require('./common_img_auth_background.png'),
  commonLogo: require('./common_logo.png'),
};

export default images;
